export default __webpack_public_path__ + "static/media/registrerWallpaper.af270286.jpg";